/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { IdentityApiConfiguration as __Configuration } from '../identity-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FileConfiguration } from '../models/file-configuration';
@Injectable({
  providedIn: 'root',
})
class FileConfigurationService extends __BaseService {
  static readonly GetPath = '/configuration';
  static readonly PostPath = '/configuration';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  GetResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/configuration`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }  Get(): __Observable<null> {
    return this.GetResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param fileConfiguration undefined
   */
  PostResponse(fileConfiguration?: FileConfiguration): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = fileConfiguration;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/configuration`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param fileConfiguration undefined
   */
  Post(fileConfiguration?: FileConfiguration): __Observable<null> {
    return this.PostResponse(fileConfiguration).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module FileConfigurationService {
}

export { FileConfigurationService }
